import * as React from 'react';
import AnonymousLayout from '../layouts/AnonymousLayout';
import { getVettingLogo } from '../../lib/utils';

const InvalidOrExpired = () => {
	return (
		<AnonymousLayout title="Invalid Link" renderHeading logo={getVettingLogo()}>
			<p>You have clicked an invalid or expired link.</p>
		</AnonymousLayout>
	);
};

export default InvalidOrExpired;
